import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import ContactSupport from '../pages/user/ContactSupport';

// Renders the full ContactSupport form inside a floating dialog so it can be
// opened from anywhere (Operations view, Admin Control Center) without
// navigating away from the current context.
const ContactSupportDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 1 }}>
      <Box sx={{ fontSize: '1rem', fontWeight: 600 }}>Contact Support</Box>
      <IconButton size="small" onClick={onClose} aria-label="Close">
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers sx={{ p: 0 }}>
      <ContactSupport onClose={onClose} />
    </DialogContent>
  </Dialog>
);

export default ContactSupportDialog;
